import { Button } from '@/components/Button'
import imgSendPromptMessageUrl from '@/assets/misc/img_send-prompt-message.svg'
import TeamRolesIllustration from '@/components/SpotIllustration/TeamRolesIllustration'
import { byDesign } from '@/infra/design'
import {
  ModalSheet,
  ModalSheetContent,
  ModalSheetContentBlock,
  ModalSheetContentDescription,
  ModalSheetContentIllustration,
  ModalSheetContentTitle,
  ModalSheetFooter,
  ModalSheetFooterButtonGroup,
  ModalSheetFooterSpacer,
  ModalSheetHeader,
} from '@/components/ModalSheet'

export interface ApproveDraftInReviewDialogProps {
  showing: boolean
  isApprovePending: boolean
  onClose: () => unknown
  onApprove: () => unknown
}

export function ApproveDraftInReviewDialog({
  showing,
  isApprovePending,
  onClose,
  onApprove,
}: ApproveDraftInReviewDialogProps) {
  return (
    <ModalSheet
      showing={showing}
      onRequestClose={isApprovePending ? undefined : onClose}
    >
      <ModalSheetHeader withCloseButton />
      <ModalSheetContent>
        <ModalSheetContentIllustration
          src={imgSendPromptMessageUrl}
          illustration={byDesign(undefined, TeamRolesIllustration)}
        />
        <ModalSheetContentBlock>
          <ModalSheetContentTitle>
            Are you sure that you approve the latest draft return?
          </ModalSheetContentTitle>
          <ModalSheetContentDescription>
            If accepted, the Pro will be able to close the job.
          </ModalSheetContentDescription>
        </ModalSheetContentBlock>
      </ModalSheetContent>
      <ModalSheetFooter>
        <ModalSheetFooterSpacer />
        <ModalSheetFooterButtonGroup>
          <Button
            label="Cancel"
            variant="secondary"
            onPress={onClose}
            isDisabled={isApprovePending}
          />
          <Button
            label="Yes"
            testId="approve-draft-dialog-yes-button"
            variant="primary"
            isPending={isApprovePending}
            isDisabled={isApprovePending}
            onPress={onApprove}
          />
        </ModalSheetFooterButtonGroup>
      </ModalSheetFooter>
    </ModalSheet>
  )
}
